// src/utils/brandNameCorrections.js
// The backend's English brand names were machine-translated from Korean and
// many are wrong (미샤 → "Mischa" instead of MISSHA). Until the backend data
// is fixed, this overlay rewrites known-bad names in API responses.
// Source of truth: src/constants/brandNameCorrections.en.json — the same file
// is meant to be applied to the backend DB, after which this overlay can go.
import CORRECTIONS from '../constants/brandNameCorrections.en.json';

const BY_ID = {};
const BY_WRONG_NAME = {};
Object.entries(CORRECTIONS).forEach(([id, c]) => {
  BY_ID[id] = c.en;
  if (c.wrong) BY_WRONG_NAME[c.wrong.toLowerCase()] = c.en;
});

const fixName = (name, brandId, lang) => {
  if (lang === 'en' && brandId && BY_ID[brandId]) return BY_ID[brandId];
  if (typeof name === 'string') {
    // wrong-name matching is language-safe: the broken strings only ever
    // occur in English payloads
    const hit = BY_WRONG_NAME[name.toLowerCase()];
    if (hit) return hit;
  }
  return name;
};

/**
 * Deep-walks an API response and corrects brand names in place.
 * Handles the three shapes the backend uses:
 *  - objects with brand_id + brand_name (rankings, search)
 *  - objects with brand_name only (details, product basic_info)
 *  - brand_distribution.labels string arrays (trend metrics)
 */
export const applyBrandNameCorrections = (data, lang) => {
  const visit = (node, key) => {
    if (Array.isArray(node)) {
      if (key === 'labels') {
        node.forEach((v, i) => {
          node[i] = fixName(v, null, lang);
        });
      } else {
        node.forEach((child) => visit(child, key));
      }
      return;
    }
    if (node && typeof node === 'object') {
      if (typeof node.brand_name === 'string') {
        node.brand_name = fixName(node.brand_name, node.brand_id, lang);
      }
      Object.entries(node).forEach(([k, v]) => visit(v, k));
    }
  };
  visit(data, null);
  return data;
};

export default applyBrandNameCorrections;
